import { useQuery } from '@tanstack/react-query';
import {
  getBrandsForSource,
  BrandsForSourceResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

const GET_BRANDS_FOR_SOURCE = 'GET_BRANDS_FOR_SOURCE';

export const useGetBrandsForSource = (
  projectId: number | null,
  source: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!source && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: brandsForSource,
    isLoading,
    isError,
    error,
  } = useQuery<BrandsForSourceResponse>({
    queryKey: [GET_BRANDS_FOR_SOURCE, projectId, source, chatType, fromTimestamp, toTimestamp, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getBrandsForSource(projectId!, source, chatType!, from, to, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    brandsForSource: queryEnabled ? brandsForSource ?? null : null,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
  };
};
